/**
 * LOD da animação dos avatares (F49): a pose a cada quadro até 20 m, a cada 2 até 40 m, a cada 4 até
 * 80 m vezes a distância de visão da qualidade; mais longe ou fora da tela, parada. O tempo pulado se
 * acumula e entra todo no quadro que atualiza (o clipe não fica para trás).
 */
export const AVATAR_LOD = { full: 20, half: 40, quarter: 80 } as const;

/** Teto do tempo acumulado (s): de volta à tela depois de muito tempo, o estado não pula minutos. */
const MAX_PENDING = 1;

/** Quadros por atualização: 1, 2 ou 4; 0 = parada. `range` é a distância de visão (`QUALITY.distance`). */
export function animationEvery(distance: number, visible: boolean, range: number): 0 | 1 | 2 | 4 {
  if (!visible || distance > AVATAR_LOD.quarter * range) return 0;
  if (distance <= AVATAR_LOD.full) return 1;
  return distance <= AVATAR_LOD.half ? 2 : 4;
}

/**
 * Relógio de um avatar: acumula o tempo e diz quando atualizar. `slot` desencontra os avatares (com
 * a mesma cadência, cada um atualiza num quadro), para o custo não vir todo junto.
 */
export class AnimationLod {
  private pending = 0;
  private readonly slot: number;
  /** Estava parada no quadro anterior: ao voltar, atualiza na hora (sem esperar a vez do desencontro). */
  private frozen = false;
  /** Cadência da última decisão (para o `stats()`). */
  every: 0 | 1 | 2 | 4 = 1;

  constructor(slot: number) {
    this.slot = slot;
  }

  /** O tempo a aplicar neste quadro (`frame` conta os quadros da cena), ou `undefined` se não atualiza. */
  step(dt: number, frame: number, every: 0 | 1 | 2 | 4): number | undefined {
    this.every = every;
    this.pending = Math.min(MAX_PENDING, this.pending + dt);
    const resumed = this.frozen && every > 0;
    this.frozen = every === 0;
    if (every === 0 || (!resumed && (frame + this.slot) % every !== 0)) return undefined;
    const out = this.pending;
    this.pending = 0;
    return out;
  }
}
